import { render, staticRenderFns } from "./DialogImportacao.vue?vue&type=template&id=70a9c392&scoped=true"
import script from "./DialogImportacao.vue?vue&type=script&lang=js"
export * from "./DialogImportacao.vue?vue&type=script&lang=js"
import style0 from "./DialogImportacao.vue?vue&type=style&index=0&id=70a9c392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a9c392",
  null
  
)

export default component.exports